module.exports = __webpack_public_path__ + "static/operating-59435acbaf0103e2d9f737e3b3706b71.jpg";